import React, { useState, useEffect, useCallback } from 'react';
import iconAdd from '../../../assets/images/icon_add_blue.svg';
import AutosizeInput from 'react-input-autosize';

export default (props) => {
  const { editItem, item } = props;

  const [suggestionList, setSuggestionList] = useState([]);
  const [isExpanded, setIsExpanded] = useState(true);

  useEffect(() => {
    if (item && item.suggestionList) {
      setSuggestionList(item.suggestionList);
    }
  }, [item]);

  const handleExpand = useCallback(() => {
    setIsExpanded((oldState) => !oldState);
  }, []);

  const doUpdateItem = (payload) => {
    editItem({ ...item, ...payload });
  };

  const handleAddKeyValue = () => {
    if (suggestionList.length < 10) {
      setSuggestionList([...suggestionList, '']);
    }
  };

  const removeVoidButtons = (list) => {
    let fixed = list.filter((item) => {
      if (item.length > 0) {
        return item;
      }
    });
    return fixed;
  };

  const handleOnBlur = (list) => {
    const fixed = removeVoidButtons(list);
    setSuggestionList(fixed);
    doUpdateItem({ suggestionList: fixed });
  };

  const changeValue = (index, e) => {
    let changedList = [...suggestionList];
    const inputLength = e.target.value.length;

    if (inputLength <= 20) {
      changedList[index] = e.target.value;
      setSuggestionList(changedList);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      const fixed = removeVoidButtons(suggestionList);
      setSuggestionList(fixed);
      doUpdateItem({ suggestionList: fixed });
    }
  };

  const deleteValue = async (index) => {
    let newArray = suggestionList;
    newArray.splice(index, 1);
    setSuggestionList(newArray);
    doUpdateItem({ suggestionList: newArray });
  };

  return (
    <>
      <div className="sugestion-list-header" onClick={handleExpand}>
        <p>Resposta Rápida</p>
        <img
          alt="Seta"
          src="/assets/images/icons/seta_close.svg"
          className={isExpanded ? '' : 'is-expanded-arrow'}
        />
      </div>
      {/* { Listagem de Sugestões} */}
      {isExpanded && (
        <div className="header-customizado-api">
          <ul className="suggestio-list">
            {suggestionList.map((row, index) => (
              <li key={index} className="suggestion-iten">
                <AutosizeInput
                  name="form-field-name"
                  value={suggestionList[index]}
                  onChange={(e) => {
                    changeValue(index, e);
                  }}
                  onKeyDown={(e) => {
                    handleKeyDown(e);
                  }}
                  onBlur={() => handleOnBlur(suggestionList)}
                  inputStyle={{ height: '23px', minWidth: '110px' }}
                />
                <img
                  alt="close"
                  src="/static/media/icon_delete_custom.cbd29cc8.svg"
                  onClick={() => {
                    deleteValue(index);
                  }}
                />
              </li>
            ))}
            <li className="suggestion-iten-add" onClick={handleAddKeyValue}>
              <img src={iconAdd} alt="adicionar" />
              <p>Nova Resposta</p>
            </li>
          </ul>
        </div>
      )}
    </>
  );
};
